import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from './core/service/token.service';
import { Store } from '@ngrx/store';
import { SweetAlert } from 'src/app/shared/alert/sweet-alert';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { Location } from '@angular/common';
import { CallbackSigninService } from 'src/app/auth/containers/callback-signin/callback-signin.service';
import { CookieService } from 'ngx-cookie-service';
import { McDataService } from 'src/app/core/service/mc-data.service';
import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';
import { DataShareService } from 'src/app/core/service/data-share.service';

declare let window: any;
@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit, OnDestroy {
  udid : any;
  alertService: SweetAlert = new SweetAlert();

  currentPath: String = '';
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date;
  jwtHelper: JwtHelperService = new JwtHelperService();

  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private location: Location,
    private tokenService: TokenService,
    private store: Store<any>,
    private router: Router,
    private route: ActivatedRoute,
    private callbackPageService: CallbackSigninService,
    private mcDataService: McDataService,
    private cookiesService: CookieService,
    private dataShareService: DataShareService
  ) {
    this.setUdid()
    const data= this.tokenService.getDataToken()

    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === 'idleState' && event.newValue === 'Started') {
        idle.watch();
      }
      if (event.key === 'idleState' && event.newValue === 'Stopped') {
        idle.stop();
      }
    });
    // sets an idle timeout of 5 seconds, for testing purposes.
    // idle.setIdle(5);

    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(5);

    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    // do something when the user is no longer idle
    idle.onIdleEnd.subscribe(() => {
     this.idleState = 'No longer idle.'
     console.log('#### ' + this.idleState)
   });

    idle.onTimeout.subscribe(() => {
        this.idleState = 'Timed out!';
        this.timedOut = true;
        console.log('#### Timed out : '  + new Date());
        this.clearAccessToken();
    });

    // do something when the user becomes idle
    idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!'
      console.log('#### ' + this.idleState)
    });

    idle.onTimeoutWarning.subscribe((countdown : any) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!'
      console.log('#### ' + this.idleState)
    });

    // Sets the ping interval to 15 seconds
    keepalive.interval(15);

    keepalive.onPing.subscribe(() => {
      this.lastPing = new Date()
      console.log('#### Ping Time :' + new Date())
    });

    // Lets check the path everytime the route changes, stop or start the idle check as appropriate.
    router.events.subscribe((val) => {
        this.currentPath = location.path();
        if (this.currentPath.search('/callback-signin') === -1) {
           if (this.cookiesService.get('maxTimeToken')) {
             idle.watch();
             idle.setIdle(Number(this.cookiesService.get('maxTimeToken')));
             localStorage.setItem('idleState', 'Started');
           }
        } else {
          idle.stop();
          localStorage.setItem('idleState', 'Stopped');
        }
    });

    this.dataShareService.sharingData.subscribe((res: any) => {
      if (res.module === 'intercept') {
        idle.stop();
        localStorage.setItem('idleState', 'Stopped');
      }
    });
  }

  ngOnInit() {
     if (localStorage.getItem('clearTokenIds') === "false") {
       this.redirectLogin();
     }
  }

  reset() {
      this.idle.watch();
      localStorage.setItem('idleState', 'Started');
      this.idleState = 'Started.';
      this.timedOut = false;
  }

  async clearAccessToken(){
    if (this.cookiesService.get('accessToken')) {
      await this.callbackPageService.logOutToken()
    }

    this.cookiesService.deleteAll();
    sessionStorage.clear();
    localStorage.setItem('clearTokenIds', 'false');

    this.alertService.error('','ไม่มีการใช้งานเป็นระยะเวลานาน (session หมดอายุ) <br/> กรุณาเข้าสู่ระบบใหม่อีกครั้ง' ).then(()=>{
      this.redirectLogin();
    });
  }

  redirectLogin() {
    // const ids_Token = this.mcDataService.getIdsToken()
    const ids_Token = localStorage.getItem('idsToken');
    const clearTokenIds = localStorage.getItem('clearTokenIds');

    if(!!ids_Token && ids_Token !== "" && ids_Token !== undefined && !this.jwtHelper.isTokenExpired(ids_Token)
      && clearTokenIds === "false"
      ){
      let urlLogout = environment.idsLogin.logOut + 'id_token_hint=' + ids_Token + '&post_logout_redirect_uri=' + environment.idsLogin.redirect_url;
      window.location.href = urlLogout;
    }
    else {
      window.location.href = "/callback-signin";
    }
    localStorage.clear();
  }

  isDeveloperMode(): boolean {
    return 'LOCAL' === environment.name;
  }

  setUdid() {
    this.route.queryParams.subscribe((params) => { //จับ param ที่มาจาก URL
      this.udid = params["udid"]
      if(!!this.udid) {
      localStorage.setItem("udid", this.udid.replaceAll('"', ""))
      }
    });
  }

  ngOnDestroy(): void {
    localStorage.clear();
    this.dataShareService.sharingData.unsubscribe();
  }
}
